import defaultOgImage from './assets/1200x630.png';

export const SITE_NAME = 'Heretic Studio';
export const SITE_URL = 'https://www.heretic-studio.co.uk';
export const DEFAULT_DESCRIPTION =
  'Independent, UK-based concept design studio specialising in product design and websites for startups and small businesses. Transform bold ideas into user-focused digital experiences.';
export const DEFAULT_AUTHOR = 'Heretic Studio';

export const DEFAULT_LOCALE = 'en_GB';
export const DEFAULT_OG_IMAGE = defaultOgImage;
